import { fillArr, randomNum } from '@hglobal/common';
import { environment } from '@pt/environment';
import { BalanceOrderUser, UserInfoAdmin, UserProfile } from '@pt/models';

import { userStatusTypes } from './user-status-types.mocks';

export function getUserMock(id: number): UserProfile {
  return {
    id,
    fullName: 'Aleksander Sidorov' + ` ${id}`,
    imageUrl: `${environment.assetsHost}/assets/images/user-avatar-mock.jpg`,
    position: 'Head of QA',
    email: 'a.sidorov@company.team',
  };
}

export function getUsersMock(count = 12): UserProfile[] {
  return fillArr(count, i => getUserMock(i));
}

export function getOrderUserMock(id: number): BalanceOrderUser {
  return {
    ...getUserMock(id),
    phone: '+380968425369',
    location: 'UA Kyiv',
    balance: id * 1000,
  };
}

export function getOrderUsersMock(count = 12): BalanceOrderUser[] {
  return fillArr(count, i => getOrderUserMock(i));
}

export function getUserInfoAdminMock(): UserInfoAdmin {
  const segment = ['SEGMENT.TECH', null][randomNum(1)];
  return {
    id: 3335,
    picture: 'https://picsum.photos/200?random=1',
    email: 'i.petrov@company.business',
    fullName: 'Petrov Innokentiy',
    location: 'UA IT',
    locationId: 1,
    team: 'Product Office',
    position: 'Head of Front-end',
    segment,
    service: segment ? null : 'SERVICE.TECH',
    hobby: 'Some hobby, bla bla bla',
    birthday: '02-24',
    startDate: '2023-06-29',
    personalYearStart: '2023-06-29',
    slackId: '3335',
    directManager: {
      id: 1738,
      fullName: 'Aleksander Sidorov',
      email: 'o.tiukh@company.team',
      picture: 'https://picsum.photos/200?random=2',
      position: 'Head of QA',
    },
    functionalManager: {
      id: 1738,
      fullName: 'Veronika Petrova',
      email: 'o.tiukh@company.team',
      picture: 'https://picsum.photos/200?random=3',
      position: 'Team lead QA',
    },
    peoplePartner: {
      id: 1738,
      fullName: 'Svetlana Sidorova',
      email: 'o.tiukh@company.team',
      picture: '',
      position: 'Head of HR',
    },
    phone: '+380968425369',
    status: userStatusTypes[randomNum(2)],
    personalYearEnd: '2024-06-28',
    balance: 5644,
    groups: [
      { id: 1, name: 'Design team' },
      { id: 2, name: 'Frontend team' },
      { id: 3, name: 'Marketing team' },
      { id: 4, name: 'Backend team' },
      { id: 5, name: 'DevOps team' },
    ],
    achievements: fillArr(10, i => ({
      id: i,
      name: `Achievement ${i}`,
      image: {
        id: i,
        url: `https://picsum.photos/200?random=${i}`,
        name: `Achievement ${i}`,
      },
      achievedCount: 0,
    })),
  };
}
